module.exports = __webpack_public_path__ + "img/FR11978.e59da7d4.svg";